var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { TabHeader, InputSearchBase, Table, BtnDropdown, ModalUploadStudents, ButtonBorderedKVBase, ScoreMarker } from '@/presentation/components';
import HeaderMenu from '@/presentation/components/header-menu/header-menu';
import IconButton from '@/presentation/components/icon-button/icon-button';
import { IconEdit } from '@/presentation/components/icons';
import { mapToCardinal, toCardinal } from '@/presentation/functions/cardinal';
import { Container, Row, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { manageIndividualClassAtom } from './components/atoms';
import EditClassModal from './components/edit-class-modal/edit-class-modal';
import Styles from './manage-individual-class-styles.scss';
import TableNotFound from '@/presentation/components/table/table-not-found/table-not-found';
import UseManageIndividualClass from './hooks/use-manage-individual-class';
import ModalAddStudentsManually from '../manage-students/components/modal-add-students-manually/modal-add-students-manually';
import ModalCheckout from '../manage-students/components/modal-checkout/modal-checkout';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { uploadFromCsvStudentState } from '@/presentation/components/upload-from-file/students/atoms';
import { addStudentsManuallyAtom } from '../manage-students/components/modal-add-students-manually/atoms';
import { manageStudentsAtom } from '../manage-students/components/atoms';
import { CSVLink } from 'react-csv';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
const ManageIndividualClass = ({ saveCsvFile, validationModalUpload, validationAddStudent, validationModalUploadTeachers, manageClasses: manageClassesService, manageUsers, loadUsersPaginated, loadUsers, getClass, getInfo, validationModalCheckout, getStripePage, manageStripe, manageQuizzesUsers, managePreQuiz }) => {
    var _a, _b, _c, _d, _e;
    const [state, setState] = useRecoilState(manageIndividualClassAtom);
    const setUploadFromCsvStudentState = useSetRecoilState(uploadFromCsvStudentState);
    const setAddStudentsManuallyState = useSetRecoilState(addStudentsManuallyAtom);
    const stateManageStudent = useRecoilValue(manageStudentsAtom);
    const [showExportModal, setShowExportModal] = useState(false);
    const { showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const navigate = useNavigate();
    const { idClass: idClassParam } = useParams();
    const idClass = parseInt(idClassParam);
    const { getIdClient, user } = useUserSesssion();
    const idClient = getIdClient();
    const { columns, columnsWithoutSort, getStudentsPaginated, renderCellByType, mapDataForCSV, getAllData, score } = UseManageIndividualClass(loadUsersPaginated, loadUsers, manageClassesService, idClass, idClient, getClass, Styles, manageQuizzesUsers, managePreQuiz);
    const mapTeachers = (teachers) => {
        const response = teachers === null || teachers === void 0 ? void 0 : teachers.map(teacher => {
            return (React.createElement("span", { key: teacher.id }, teacher === null || teacher === void 0 ? void 0 :
                teacher.title,
                " ",
                teacher.firstName,
                " ",
                teacher.lastName));
        });
        return response;
    };
    const printGrades = (grades) => {
        return grades === null || grades === void 0 ? void 0 : grades.map(item => toCardinal(item)).join(',');
    };
    const printClassAverage = (classAverage) => {
        const response = (classAverage * 100).toFixed(0);
        return response;
    };
    const DataNotFoundComp = () => {
        return (React.createElement(TableNotFound, { onClick: () => {
                setState(prev => {
                    return Object.assign(Object.assign({}, prev), { filters: {
                            input: '',
                            deleted: false,
                            selectedGradeId: null
                        }, dataNotFound: false });
                });
            }, term: state.filters.input !== '' ? state.filters.input : null }));
    };
    const onSuccessCSV = () => {
        setState(prev => (Object.assign(Object.assign({}, prev), { modalCheckout: true })));
    };
    const openModalCSV = () => {
        setUploadFromCsvStudentState(prev => {
            var _a, _b, _c;
            return (Object.assign(Object.assign({}, prev), { openMainModal: true, mainTitle: `Add students from CSV to the Class ${(_b = mapToCardinal((_a = state.class) === null || _a === void 0 ? void 0 : _a.grades)) === null || _b === void 0 ? void 0 : _b.join(',')} Grade, ${(_c = state.class) === null || _c === void 0 ? void 0 : _c.name}`, finalTextButton: 'Confirm and Proceed to Payment' }));
        });
    };
    const downloadAllData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _f;
        try {
            const result = yield getAllData();
            if (result && result.length > 0) {
                (_f = document.getElementById('btnDownloadCSV_AllStudents')) === null || _f === void 0 ? void 0 : _f.click();
            }
        }
        catch (error) {
            console.log({
                error
            });
            showCustomError('Error', 'Error downloading data');
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.manageClassWrap },
            React.createElement(HeaderMenu, { title1: "Manage Class", onBack: () => navigate(user.role.description === 'Teacher' ? `/teacher-dashboard/manage-classes` : `/school-dashboard/manage-classes`) }),
            React.createElement(Card, { className: Styles.card },
                React.createElement(Card.Body, null,
                    user.role.description !== 'Teacher' && (React.createElement(Card.Title, { className: "d-flex justify-content-end" },
                        React.createElement(IconButton, { onClick: () => setState(prev => (Object.assign(Object.assign({}, prev), { isEditClassModalVisible: true }))) },
                            React.createElement(IconEdit, { color: "#00A3FF" })))),
                    React.createElement(Container, { fluid: true },
                        React.createElement(Row, { className: "justify-content-center text-center" },
                            React.createElement("span", { className: Styles.title1 }, (_a = state.class) === null || _a === void 0 ? void 0 : _a.name)),
                        React.createElement(Row, { className: "justify-content-center text-center" },
                            React.createElement("div", { className: Styles.title2 },
                                React.createElement("span", null, "Class Grade:"),
                                printGrades((_b = state.class) === null || _b === void 0 ? void 0 : _b.grades),
                                "\u00A0\u00A0\u00A0",
                                React.createElement("span", null, "Teacher: "),
                                mapTeachers((_c = state.class) === null || _c === void 0 ? void 0 : _c.teachers),
                                "\u00A0\u00A0\u00A0")),
                        React.createElement(Row, { className: "justify-content-center text-center" },
                            React.createElement("div", { className: Styles.title2 },
                                React.createElement("span", null, "School: "), (_e = (_d = state.class) === null || _d === void 0 ? void 0 : _d.client) === null || _e === void 0 ? void 0 :
                                _e.name)),
                        React.createElement(Row, { className: "justify-content-center text-center" },
                            React.createElement(ScoreMarker, { title: 'Class Cumulative Score:', percentage: score, backgroundColor: 'green' }))))),
            React.createElement("div", null,
                React.createElement("div", { className: Styles.tableWrapper },
                    React.createElement(TabHeader, { title: "Students" },
                        React.createElement(InputSearchBase, { loading: state.isTableLoading, customStyle: Styles.search, placeholder: "Search...", onChange: (event) => {
                                setState(prev => {
                                    return Object.assign(Object.assign({}, prev), { filters: {
                                            input: event.target.value,
                                            selectedGradeId: null
                                        } });
                                });
                            } }),
                        React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 0.2 } },
                            React.createElement(ButtonBorderedKVBase, { type: "button", color: "#00A3FF", onClick: () => setShowExportModal(true), btnWrapClass: Styles.btnExportWrapClass }, "Export"),
                            React.createElement(CSVLink, { id: "btnDownloadCSV_students", style: { display: 'none' }, data: mapDataForCSV(state.students.data), filename: `students_${new Date().getTime()}.csv` }, "Exportar a CSV"),
                            React.createElement(CSVLink, { id: "btnDownloadCSV_AllStudents", style: { display: 'none' }, data: mapDataForCSV(state.allStudents), filename: `students_${new Date().getTime()}.csv` }, "Exportar a CSV")),
                        user.role.description !== 'Teacher' && (React.createElement("div", { style: { flex: 2 } },
                            React.createElement(BtnDropdown, { title: "Add Students", items: [
                                    {
                                        label: 'Add from CSV',
                                        onClick: () => openModalCSV()
                                    },
                                    {
                                        label: 'Add Manually',
                                        onClick: () => setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: true })))
                                    }
                                ] })))),
                    React.createElement(Table, { columns: columns, data: state.students.data, dataNotFound: state.dataNotFound, DataNotFoundComponent: () => {
                            return React.createElement(DataNotFoundComp, null);
                        }, columnsWithoutSort: columnsWithoutSort, renderCellByType: renderCellByType, pagination: {
                            total: state.students.total,
                            page: state.students.page,
                            count: state.students.count,
                            pageCount: state.students.pageCount
                        }, fetchData: (pagination, sort) => {
                            getStudentsPaginated(state.filters, pagination, sort);
                        }, filters: state.filters, loading: state.isTableLoading })))),
        React.createElement(EditClassModal, { manageClassesService: manageClassesService, idClass: idClass }),
        React.createElement(ModalAddStudentsManually, { validationAddStudent: validationAddStudent, idClient: idClient, saveCsvFile: saveCsvFile }),
        React.createElement(ModalUploadStudents, { validation: validationModalUploadTeachers, saveCsvFile: saveCsvFile, idClient: idClient, idClass: idClass, onSuccess: onSuccessCSV }),
        stateManageStudent.modalCheckout && React.createElement(ModalCheckout, { manageStripe: manageStripe, idClient: idClient }),
        showExportModal && (React.createElement("div", { className: Styles.modalExportData },
            React.createElement("div", { className: Styles.content },
                React.createElement("h3", null, "Export Data"),
                React.createElement("p", null, "What information would you like to download?"),
                React.createElement("div", { className: Styles.buttons },
                    React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => {
                            setShowExportModal(false);
                            downloadAllData();
                        } }, "Export all data"),
                    React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => {
                            var _a;
                            setShowExportModal(false);
                            (_a = document.getElementById('btnDownloadCSV_students')) === null || _a === void 0 ? void 0 : _a.click();
                        } }, "Export current data")),
                React.createElement("button", { type: "button", className: Styles.cancel, onClick: () => {
                        setShowExportModal(false);
                    } }, "Cancel"))))));
};
export default ManageIndividualClass;
